import { createSlice } from '@reduxjs/toolkit';
import { ICreateOrderSliceInitialState } from 'src/app/Orders/order.interface';
import { RootState } from 'src/redux/store';

export type OrderKeysType = 'shipper_details' | 'consignee_details' | 'load_details' | 'order_details' | 'documents' | 'review_finalize';

export const ORDER_KEYS: Record<string, OrderKeysType> = {
    SHIPPER_DETAILS: 'shipper_details',
    CONSIGNEE_DETAILS: 'consignee_details',
    LOAD_DETAILS: 'load_details',
    ORDER_DETAILS: 'order_details',
    DOCUMENTS: 'documents',
    REVIEW_FINALIZE: 'review_finalize',
};

const initialState: ICreateOrderSliceInitialState = {
    loading: true,
    error: null,
    data: {
        orderInfo: null,
        isDraft: true,
        currentStep: ORDER_KEYS.SHIPPER_DETAILS,
        orderIsFromQuote: null,
        completedSteps: [],
        draftOrderLegId: null,
        isDraftSaving: false,
    },
    customerDropdownOptions: {
        recentCustomerList: [],
        searchCustomerList: [],
        divisionList: [],
        billingAccountList: [],
    },
    brokerList: [],
    shipperContacts: {
        recentShipperContacts: [],
        searchShipperContacts: [],
    },
    consigneeContacts: {
        recentConsigneeContacts: [],
        searchConsigneeContacts: [],
    },
};

export const CreateOrdersSlice = createSlice({
    name: 'CreateOrders',
    initialState,
    reducers: {
        setData: (state, { payload }) => {
            state.data = { ...state.data, ...payload };
        },
        setCreateOrderData: (state, { payload }) => {
            if (payload.data?.brokerDetails && state.data.orderInfo?.brokerDetails?.documents) {
                payload.data.brokerDetails = {
                    ...payload.data.brokerDetails,
                    documents: state.data.orderInfo.brokerDetails.documents,
                };
            }
            state.data.orderInfo = { ...state.data.orderInfo, ...payload.data };
        },
        setCreateOrderStep: (state, { payload }) => {
            state.data.currentStep = payload;
        },
        setCompletedStep: (state, { payload }) => {
            state.data.completedSteps = payload;
        },
        setShipperContacts: (state, { payload }) => {
            state.shipperContacts = { ...state.shipperContacts, ...payload };
        },
        setDocuments: (state, { payload }) => {
            if (!state.data.orderInfo) {
                state.data.orderInfo = {
                    brokerDetails: { documents: [] },
                } as any;

                return;
            }

            if (!state.data.orderInfo.brokerDetails) {
                state.data.orderInfo.brokerDetails = { documents: [] };
            }
            state.data.orderInfo.brokerDetails.documents = payload;
        },
    },
});

export const { setCreateOrderData, setCreateOrderStep, setData, setCompletedStep, setDocuments } = CreateOrdersSlice.actions;

export const shipperOrderInfo = (state: RootState): any => state.CreateOrders.data?.orderInfo?.shipperDetails;
export const consigneeOrderInfo = (state: RootState): any => state.CreateOrders.data?.orderInfo?.consigneeDetails;

export const completedSteps = (state: RootState): string[] => state.CreateOrders.data?.completedSteps || [];

export const isDraftSaving = (state: RootState): boolean => state.CreateOrders.data?.isDraftSaving || false;

export default CreateOrdersSlice.reducer;
